<div class="add-to-watchlist-popup">
  <div class="dialog-header d-flex justify-content-between align-items-center">
    <h2 class="modal-title mb-0">{{ successMessage ? 'Added to Watchlist' : 'Add to Watchlists' }}</h2>
    <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
  </div>

  <div class="dialog-body p-3">
    <div class="alert alert-warning d-flex align-items-start gap-2 mb-3" *ngIf="hasIneligibleCompanies">
      <i class="bi bi-exclamation-triangle flex-shrink-0"></i>
      <span>Only public companies with a GICS assignment can be added to watchlists. Some selected companies may not be eligible.</span>
    </div>

    <div class="alert alert-success d-flex align-items-start gap-2 mb-3" *ngIf="successMessage">
      <i class="bi bi-check-circle flex-shrink-0"></i>
      <span>{{ successMessage }}</span>
    </div>
   

    <div class="alert alert-danger d-flex align-items-start gap-2 mb-3" *ngIf="errorMessage">
      <i class="bi bi-x-circle flex-shrink-0"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <div class="watchlist-selection" *ngIf="!successMessage">
      <div class="watchlist-list">
        <div
          *ngFor="let watchlist of watchlists"
          class="watchlist-item"
          [class.selected]="isWatchlistSelected(watchlist.watchlist_id)"
          [class.has-companies]="hasAnyCompanyInWatchlist(watchlist.watchlist_id)">
          <div class="watchlist-content" (click)="toggleWatchlistSelection(watchlist.watchlist_id)">
            <input
              type="checkbox"
              class="form-check-input watchlist-checkbox"
              [checked]="isWatchlistSelected(watchlist.watchlist_id)"
              (click)="toggleWatchlistSelection(watchlist.watchlist_id, $event)">
            <div class="watchlist-info">
              <span class="watchlist-name">{{ watchlist.watchlist_name }}</span>
              <span class="watchlist-count" *ngIf="watchlist.company_count !== undefined"> ({{ watchlist.company_count }} companies)</span>
            </div>
          </div>
          <div class="already-in-watchlist" *ngIf="hasAnyCompanyInWatchlist(watchlist.watchlist_id)">
            <i class="bi bi-check-circle-fill"></i>
            <span>Some companies in your selection are already in the watchlist.</span>
          </div>
        </div>
      </div>

      <div
        class="watchlist-item new-watchlist-option"
        [class.selected]="createNew"
        (click)="selectCreateNew()">
        <i class="bi bi-plus-circle"></i>
        <span>Add to New Watchlist</span>
      </div>

      <div class="new-watchlist-input mb-0" *ngIf="createNew">
        <label class="form-label">Watchlist name</label>
        <input
          type="text"
          class="form-control"
          [class.is-invalid]="newWatchlistName.invalid && newWatchlistName.touched"
          [formControl]="newWatchlistName"
          placeholder="Enter watchlist name">
        <div class="invalid-feedback" *ngIf="newWatchlistName.hasError('required') && newWatchlistName.touched">Watchlist name is required</div>
      </div>
    </div>
  </div>

  <div class="dialog-footer d-flex justify-content-end gap-2 p-3 border-top">
    <ng-container *ngIf="successMessage">
      <button type="button" class="btn btn-primary-popup" (click)="onClose()">Done</button>
    </ng-container>
    <ng-container *ngIf="!successMessage">
      <button type="button" class="btn btn-secondary-popup" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn btn-primary-popup" [disabled]="!canAdd() || loading" (click)="onAdd()">
        <span *ngIf="loading">Adding...</span>
        <span *ngIf="!loading">Add</span>
      </button>
    </ng-container>
  </div>
</div>
